import { fromJS, List } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import Initiative from 'models/GrowthPlan/Initiative';
import { byId } from 'store/utils/sortFunctions';
import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: {
      byId: {},
      byProject: {},
    },
    errorMessage: '',
    updatePending: false,
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.INITIATIVES_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyRequestInfo({
          data: {
            byId: action.payload.results.reduce(
              (prevData, initiative) =>
                prevData.set(initiative.id.toString(), new Initiative(initiative)).sort(byId),
              state.get('data').get('byId')
            ),
            byProject: state
              .get('data')
              .get('byProject')
              .set(
                String(action.payload.project),
                fromJS(action.payload.results.map(goal => new Initiative(goal))).sort(byId)
              ),
          },
        })
      );
    case types.INITIATIVE_FETCH_SUCCEEDED:
    case types.INITIATIVE_CREATE_SUCCEEDED:
    case types.INITIATIVE_UPDATE_SUCCEEDED: {
      const projectId = String(action.payload.project);
      const projectGoals = state
        .get('data')
        .get('byProject')
        .get(projectId, new List())
        .filter(goal => goal.id !== action.payload.id)
        .push(new Initiative(action.payload))
        .sort(byId);
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: false,
          data: {
            byId: state
              .get('data')
              .get('byId')
              .set(action.payload.id.toString(), new Initiative(action.payload)),
            byProject: state.get('data').get('byProject').set(projectId, projectGoals),
          },
        })
      );
    }
    case types.INITIATIVE_FETCH:
    case types.INITIATIVE_CREATE:
    case types.INITIATIVE_UPDATE:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: true,
        })
      );
    case types.INITIATIVE_DELETE_SUCCEEDED: {
      const projectId = String(action.payload.project);
      const projectGoals = state
        .get('data')
        .get('byProject')
        .get(projectId, new List())
        .filter(goal => goal.id !== action.payload.id)
        .sort(byId);
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: false,
          data: {
            byId: state.get('data').get('byId').delete(action.payload.id.toString()),
            byProject: state.get('data').get('byProject').set(projectId, projectGoals),
          },
        })
      );
    }
    case types.INITIATIVE_UPDATE_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          updatePending: false,
          errorMessage: action.payload,
        })
      );
    case types.INITIATIVE_CLEAR_ERROR:
      return state.merge(reduxHelper.applyReceiveInfo());
    case types.INITIATIVE_FETCH_FAILED:
    case types.INITIATIVES_LIST_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
